export function isTwoDigitNumber(value) {
  // Convert the value to a string
  const strValue = value.toString();

  // Check if the string is exactly 2 characters long and consists of digits
  return strValue.length === 2 && /^\d{2}$/.test(strValue);
}
